function setIframeSrc(targetModalId, srcValue) {
  const targetIframe = document.querySelector(`#${targetModalId} .p-stage-modal__map iframe`);
  targetIframe.src = srcValue;
}

function handleEvent(selector, callback) {
  document.querySelectorAll(selector).forEach(el => {
    el.addEventListener('click', function() {
      const targetModalId = this.getAttribute('data-simplemodal-trigger');
      callback(targetModalId);
    });
  });
}

handleEvent('.p-stage-spots-detail__item__textWrap__mapBtn', (targetModalId) => {
  const srcValue = document.querySelector(`#${targetModalId} .p-stage-modal__map iframe`).getAttribute('data-src');
  setIframeSrc(targetModalId, srcValue);
});

handleEvent('.c-ui-button[data-simplemodal-trigger], .c-ui-modal__overlay', (targetModalId) => {
  setIframeSrc(targetModalId, '');
});